import { ThemeDefinition } from 'vuetify';
import chalkboard from './assets/chalkboard.webp';
import lightBackground from './assets/background_light.png';

export const gamesLight: ThemeDefinition = {
  dark: false,
  colors: {
    brand: '#4c535d',
    'on-brand': '#ffffff',
    'brand-original': '#67717e',
    'on-brand-original': '#ffffff',
    accent: '#333333',
    'on-accent': '#ffffff',
    'accent-original': '#333333',
    'on-accent-original': '#ffffff',
    primary: '#3b4859',
    'on-primary': '#ffffff',
    'primary-container': '#d1d7e0',
    'on-primary-container': '#181e25',
    secondary: '#3d4043',
    'on-secondary': '#ffffff',
    'secondary-container': '#d7d9db',
    'on-secondary-container': '#1d1f21',
    tertiary: '#1a1a1a',
    'on-tertiary': '#ffffff',
    'tertiary-container': '#d9d9d9',
    'on-tertiary-container': '#1f1f1f',
    surface: '#fafafa',
    'on-surface': '#121c2a',
    'on-surface-medium': '#333e4d',
    'on-surface-low': '#8a97a8',
    outline: '#737e8c',
    'outline-variant': '#c7ccd2',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#333333',
    'inverse-on-surface': '#fafafa',
    'inverse-primary': '#d1d8e0',
    'primary-fixed': '#d1d8e0',
    'on-primary-fixed': '#181e25',
    'primary-fixed-dim': '#a9b6c6',
    'secondary-fixed': '#d7d9db',
    'on-secondary-fixed': '#1d1f21',
    'secondary-fixed-dim': '#afb2b7',
    'tertiary-fixed': '#d9d9d9',
    'on-tertiary-fixed': '#1f1f1f',
    'tertiary-fixed-dim': '#b3b3b3',
    'surface-dim': '#d6d6d6',
    'surface-bright': '#fcfcfc',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#f5f5f5',
    'surface-container': '#f0f0f0',
    'surface-container-high': '#e5e5e5',
    'surface-container-highest': '#e1e1e1',
  },
  variables: {
    'games-background-image': `url(${lightBackground})`,
  },
};

export const gamesDark: ThemeDefinition = {
  dark: true,
  colors: {
    brand: '#b4b1b9',
    'on-brand': '#1e1d20',
    'brand-original': '#babaab',
    'on-brand-original': '#fafafa',
    accent: '#262626',
    'on-accent': '#e5e5e5',
    'accent-original': '#333333',
    'on-accent-original': '#fafafa',
    primary: '#d4d4ce',
    'on-primary': '#20201d',
    'primary-container': '#515148',
    'on-primary-container': '#f3f3f1',
    secondary: '#d3d3cf',
    'on-secondary': '#20201d',
    'secondary-container': '#505049',
    'on-secondary-container': '#fafafa',
    tertiary: '#cfcfcf',
    'on-tertiary': '#1f1f1f',
    'tertiary-container': '#4d4d4d',
    'on-tertiary-container': '#fdf6f8',
    surface: '#1e2124',
    'on-surface': '#fcfcf3',
    'on-surface-medium': '#d1d1c7',
    'on-surface-low': '#a3a38f',
    outline: '#cfcfc9',
    'outline-variant': '#878778',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#e4e5e7',
    'inverse-on-surface': '#20201d',
    'inverse-primary': '#4a4a40',
    'primary-fixed': '#dbdbd6',
    'on-primary-fixed': '#21211c',
    'primary-fixed-dim': '#bdbdb3',
    'secondary-fixed': '#dbdbd7',
    'on-secondary-fixed': '#20201d',
    'secondary-fixed-dim': '#b6b6b0',
    'tertiary-fixed': '#d9d9d9',
    'on-tertiary-fixed': '#1f1f1f',
    'tertiary-fixed-dim': '#b3b3b3',
    'surface-dim': '#101214',
    'surface-bright': '#353a41',
    'surface-container-lowest': '#0e0f11',
    'surface-container-low': '#17191c',
    'surface-container': '#1e2125',
    'surface-container-high': '#272b30',
    'surface-container-highest': '#353a41',
  },
  variables: {
    'games-background-image': `url(${chalkboard})`,
  },
};
